import { render, staticRenderFns } from "./MelanieDubinBeier.vue?vue&type=template&id=5bed8b2a&"
import script from "./MelanieDubinBeier.vue?vue&type=script&lang=js&"
export * from "./MelanieDubinBeier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports